export const TOGGLE_PRODUCT = 'TOGGLE_PRODUCT';

export function toggleProduct(product) {
  return {
    type: TOGGLE_PRODUCT,
    payload: {
      product: product,
    },
  };
}



// WEBPACK FOOTER //
// ./src/modules/funnel/actions/product.js